import React, { useMemo, useState } from 'react';
import Card from 'v3/components/Card';
import { convertToBRLValue, convertToDollarValue } from 'v3/utils/formatter';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';

export default function NegotiatedValuesShow({ onChangeIsOpen = () => {}, defaultIsOpen = false }) {
  const {
    fareCompany,
    balance,
    advanceMoneyExternal,
    advanceMoney,
    margins,
    travelMargin,
    isAttended,
    isBRLCurrency,
    erpExchangeValue,
  } = useFreightValues();

  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  function onToggleCard() {
    setIsOpen(!isOpen);
    onChangeIsOpen(!isOpen);
  }

  const bennerMargin = useMemo(() => {
    if (isBRLCurrency) {
      const bennerMarginValue = margins?.benner_margin
        ? (Number(margins?.benner_margin) / 100) * Number(fareCompany?.total)
        : 0;
      return {
        value: bennerMarginValue,
        dollarValue: convertToDollarValue(bennerMarginValue, erpExchangeValue),
        percentageValue: margins?.benner_margin,
      };
    }

    const bennerMarginValue = margins?.benner_margin
      ? (Number(margins?.benner_margin) / 100) * Number(fareCompany?.totalDollarValue)
      : 0;

    return {
      value: convertToBRLValue(bennerMarginValue, erpExchangeValue),
      dollarValue: bennerMarginValue,
      percentageValue: margins?.benner_margin,
    };
  }, [margins?.benner_margin, fareCompany, isBRLCurrency]);

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Valores negociados"
        isOpen={isOpen}
        onToggleCard={onToggleCard}
        tooltipContent="Valores negociados com transportador e cliente a partir dos valores principais"
        totalsSection={
          <>
            <HeaderTotalSummary
              label="Frete tirar margem"
              totalInReal={fareCompany?.total}
              totalInDollar={fareCompany?.totalDollarValue}
            />
            {isAttended ? (
              <HeaderTotalSummary
                label="Frete negociado"
                totalInReal={balance?.value}
                totalInDollar={balance?.dollarValue}
              />
            ) : null}
          </>
        }
      />
      {isOpen && (
        <>
          {isAttended && (
            <>
              <ValueDetailsRow
                label="% máxima de adiantamento no ERP"
                value={advanceMoneyExternal?.value}
                dollarValue={advanceMoneyExternal?.dollarValue}
                percentageValue={advanceMoneyExternal?.percentage}
              />
              <ValueDetailsRow
                label="% adiantamento negociado"
                value={advanceMoney?.value}
                dollarValue={advanceMoney?.dollarValue}
                percentageValue={advanceMoney?.percentage}
                color="danger"
                labelColor="danger"
              />
            </>
          )}
          <ValueDetailsRow
            label="Frete Tirar Margem"
            value={fareCompany?.total}
            dollarValue={fareCompany?.totalDollarValue}
            hasTooltip
            tooltipContent="Base de cálculo para Frete Tirar Margem (Valor Cliente Tomador - Desconto Insumos)"
          />
          {isAttended && (
            <>
              <ValueDetailsRow
                label="Frete negociado"
                value={balance?.value}
                dollarValue={balance?.dollarValue}
                color="danger"
                labelColor="danger"
              />
              <ValueDetailsRow
                label="Margem Aplicada"
                value={Number(fareCompany?.total) - Number(balance?.value) || 0}
                dollarValue={Number(fareCompany?.totalDollarValue) - Number(balance?.dollarValue)}
                percentageValue={travelMargin}
              />
              <ValueDetailsRow
                label="Margem ERP"
                value={bennerMargin?.value}
                dollarValue={bennerMargin.dollarValue}
                percentageValue={bennerMargin.percentageValue}
                isBRLCurrency={isBRLCurrency}
                id="margem-erp"
              />
            </>
          )}
        </>
      )}
    </Card>
  );
}
